import React from 'react';
import styled from 'styled-components';
import { LightGrayColor } from 'GlobalStyles';

export const EducationWrapper = styled.div`
  .title {
    color: #000;
    font-size: 16px;
  }
  .sub-title {
    color: #000;
  }
  .extra {
    color: #747474;
  }
  .ant-list-item-meta-content {
    margin: auto;
  }
  .ant-list-item-meta-avatar {
    margin: auto;
    margin-right: 16px;
    background: ${LightGrayColor};
    border-radius: 50%;
    .empty,
    img {
      height: 64px;
      width: 64px;
      border-radius: 50%;
    }
  }
`;

export const ProfileWrapper = styled.div`
  color: #000;
  width: 100%;
  margin: auto;

  .user-type-tag {
    width: 50px;
    height: 22px;
    line-height: 20px;
    top: -10px;
    display: block;
    position: relative;
    margin: auto;
    font-size: 11px;
    border-radius: 4px;
    box-shadow: 0 0 0 2px #fff;
  }
  .name {
    font-size: calc(0.2vw + 18px);
    font-size: -webkit-calc(0.2vw + 18px);
    font-weight: bold;
  }
  .intro {
    font-size: calc(0.2vw + 10px);
    font-size: -webkit-calc(0.2vw + 12px);
  }
  .score {
    font-weight: bold;
    font-size: calc(0.2vw + 10px);
    font-size: -webkit-calc(0.2vw + 10px);
  }
  .num-of-rater {
    font-size: 12px;
    font-size: calc(0.2vw + 8px);
    font-size: -webkit-calc(0.2vw + 8px);
  }

  .ant-avatar,
  img {
    height: 130px;
    width: 130px;
    background: ${LightGrayColor};
    border-radius: 50%;
    position: relative;
    opacity: 1;
    cursor: pointer;
  }
  .ant-avatar.size-sm,
  img.size-sm {
    height: 75px;
    width: 75px;
  }
  .ant-avatar:hover:not(.no-hover),
  img:hover:not(.no-hover) {
    opacity: 0.8;
    -webkit-transform: scale(1.07);
    transform: scale(1.07);
    transition-duration: 0.8s;
  }
  .no-hover img,
  .no-hover {
    cursor: default;
  }
`;

export const MentoringClassWrapper = styled.div`
  color: #000;
  font-size: 16px;

  .small-btn {
    padding: 0px 20px !important;
    font-size: 13px;
  }
  .ant-btn {
    padding: 0px 13px !important;
  }
  .ant-btn.large-btn {
    padding: 0px 18px !important;
  }
  .ant-tabs-top > .ant-tabs-nav::before,
  .ant-tabs-bottom > .ant-tabs-nav::before,
  .ant-tabs-top > div > .ant-tabs-nav::before,
  .ant-tabs-bottom > div > .ant-tabs-nav::before {
    border-bottom: 1px solid ${LightGrayColor};
  }
  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    font-weight: bold;
  }
  .red-tag {
    color: #de4949;
    background: #ffe7e7;
    border-radius: 4px;
    border: none;
    padding: 1px 5px;
    font-size: 11px;
  }
  .gray-tag {
    color: #000;
    background: ${LightGrayColor};
    border-radius: 4px;
    border: none;
    padding: 1px 5px;
    font-size: 11px;
  }
  .class-time {
    margin-top: 5px;
    font-weight: bold;
    font-size: 22px;
    color: #000;
  }
  .btn-topic {
    cursor: default;
    padding: 5px 10px !important;
  }
  .content-title {
    font-size: 18px;
    font-weight: bold;
  }
  .content-body {
    white-space: pre-line;
    word-break: break-word;
  }
  .download-btn {
    padding: 0px 5px !important;
    font-size: 12px;
    height: 24px;
    line-height: 24px;
  }
  .small-profile {
    font-size: 13px;
    color: #000;
    .ant-avatar,
    img {
      height: 20px;
      width: 20px;
      border-radius: 50%;
      margin-right: 8px;
    }
  }
  .class-divider {
    border-top: 1px solid ${LightGrayColor};
    margin: 20px 0 !important;
  }
  .class-divider-32 {
    border-top: 1px solid ${LightGrayColor};
    margin: 28px 0 !important;
  }
  .btn-join {
    background: #fff !important;
    color: #008978 !important;
    border: 1px solid #008978 !important;
  }
  .btn-join:hover {
    font-weight: bold;
  }
`;
